<template>
    <span>
        <network-icon v-if="!isCustomTask(task)" :network="taskNetworkSlug" :taskType="taskType" />
        <span v-else-if="iconName" class="icon">
            <g-icon class="g-color-normal" :name="iconName" :type="iconType" color="brand" />
        </span>
    </span>
</template>

<script>
    import { computed } from 'vue-demi';
    import { NETWORK_TYPE_MAP } from '../../../../../constants/networks';
    import ActivationTasksMixin from '../../mixins/ActivationTasksMixin';
    import useCustomTaskIcons from '../../composables/use-custom-task-icons';
    import NetworkIcon from '../../../../../../src/components/interface/elements/NetworkIcon.vue';
    import { get } from 'lodash';

    export default {
        name: 'ActivationTaskIcon',

        props: {
            task: {
                type: Object,
                required: true
            }
        },

        mixins: [ActivationTasksMixin],

        components: {
            NetworkIcon
        },

        setup(props) {
            const iconName = computed(() => {
                return useCustomTaskIcons().getName(props.task);
            });

            const iconType = computed(() => {
                return useCustomTaskIcons().getType(props.task);
            });

            const taskNetworkSlug = computed(() => {
                return NETWORK_TYPE_MAP[props.task.type];
            });

            return {
                iconName,
                iconType,
                taskType: get(props,'task.type'),
                taskNetworkSlug
            };
        }
    };
</script>
